import { DateFilterOptionModel } from '../../../Common/Forms/models/date-filter-option.model';
import { DateQueryTypeEnum } from '../../../api/mentions/enum/date-query-type.enum';
import { dateFilterTypesEnum } from '../../../Common/Forms/enums/date-filter-types.enum';

export const monitoringDateFilterAllOption: DateFilterOptionModel = {
    label: 'All',
    value: {
        type: DateQueryTypeEnum.ALL,
        relativeStartOffsetH: null,
        relativeEndOffsetH: null
    },
    type: dateFilterTypesEnum.none
};
export const monitoringDateFilter24HourOption: DateFilterOptionModel = {
    label: 'Last 24 hours',
    value: {
        type: DateQueryTypeEnum.RELATIVE,
        relativeStartOffsetH: -24,
        relativeEndOffsetH: 0
    },
    type: dateFilterTypesEnum.last24Hours
};

export const monitoringDateFilterOptions: DateFilterOptionModel[] = [
    {
        label: 'Select ...',
        value: null,
        type: null
    },
    monitoringDateFilterAllOption,
    monitoringDateFilter24HourOption,
    {
        label: 'Last 3 days',
        value: {
            type: DateQueryTypeEnum.RELATIVE,
            relativeStartOffsetH: -72,
            relativeEndOffsetH: 0
        },
        type: dateFilterTypesEnum.last3Days
    },
    {
        label: 'Last 7 days',
        value: {
            type: DateQueryTypeEnum.RELATIVE,
            relativeStartOffsetH: -168,
            relativeEndOffsetH: 0
        },
        type: dateFilterTypesEnum.thisWeek
    },
    {
        label: 'Last 30 days',
        value: {
            type: DateQueryTypeEnum.RELATIVE,
            relativeStartOffsetH: -720,
            relativeEndOffsetH: 0
        },
        type: dateFilterTypesEnum.last30Days
    },
    {
        label: 'Custom',
        value: {
            type: DateQueryTypeEnum.ABSOLUTE,
            absoluteRange: {
                start: null,
                end: null
            }
        },
        type: dateFilterTypesEnum.custom
    }
];
